import React from 'react';
import {graphql} from 'react-relay';
import {ForecastQueryRenderer} from '../../ForecastQueryRenderer';
import CompanyViewHeader from './CompanyViewHeader';

type ClientStatus = {
	id: string;
	label: string;
	standing: 'ACTIVE' | 'INACTIVE';
};

type PrimaryContact = {
	id: string;
	firstName: string | null;
	lastName: string | null;
};

type Client = {
	id: string;
	name: string;
	website: string | null;
	city: string | null;
	country: string | null;
	region: string | null;
	statusId: string | null;
	createdAt: string | null;
	updatedAt: string | null;
};

type InnerProps = {
	client: Client | null;
	status: ClientStatus | null;
	primaryContact: PrimaryContact | null;
	companyId: string;
};

export const CompanyViewPageInner: React.FC<InnerProps> = ({client, status, primaryContact, companyId}) => {
	if (!client) {
		return <div>{'Not found'}</div>;
	}
	return <CompanyViewHeader client={client} status={status} primaryContact={primaryContact} companyId={companyId} />;
};

const companyViewPageQuery = graphql`
	query CompanyViewPage_Query($clientId: String) {
		viewer {
			actualPersonId
			company {
				id
				client(id: $clientId) {
					id
					name
					website
					city
					country
					region
					statusId
					createdAt
					updatedAt
					status {
						id
						label
						standing
					}
					primaryContact {
						id
						firstName
						lastName
					}
				}
			}
		}
	}
`;

type CompanyViewPageProps = {
	clientId: string;
};

const CompanyViewPage: React.FC<CompanyViewPageProps> = ({clientId}) => {
	return (
		<ForecastQueryRenderer
			key={'query-render-companyViewPage-' + clientId}
			query={companyViewPageQuery}
			variables={{clientId}}
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			render={(relayProps: any) => {
				const company = relayProps?.viewer?.company;
				const client = company?.client ?? null;
				const status = client?.status ?? null;
				const primaryContact = client?.primaryContact ?? null;
				const companyId = company?.id ?? '';
				return (
					<CompanyViewPageInner
						client={client}
						status={status}
						primaryContact={primaryContact}
						companyId={companyId}
					/>
				);
			}}
		/>
	);
};

export default CompanyViewPage;
